
import authentication_load from "./authentication/onLoad"
import notifier_load from "./notifier/onLoad"
import facebook from "./facebook/onLoad"
import concierge from "./concierge/onLoad"
import googleyolo from "./googleyolo/onLoad"
import { onLoad as truepush_onLoad } from "./truepush/onLoad"

const onLoad = () => {
  authentication_load()
  notifier_load()
  facebook.onLoad()
  concierge.onLoad()
  truepush_onLoad()
  googleyolo.onLoad()
}

export default onLoad
